const MINUTES_STEP = 15;
const END_OF_DAY = 60 * 24 - MINUTES_STEP;
const getTimeSelectOptions = ({
  startFrom = 0,
  endTo = END_OF_DAY,
  step = MINUTES_STEP
}) => {
  const options = [];
  for (let minutes = startFrom; minutes <= endTo; minutes += step) {
    const hours = Math.floor(minutes / 60) % 24;
    const mins = minutes % 60;
    options.push(`${hours.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}`);
  }
  return options;
};
export {
  END_OF_DAY,
  MINUTES_STEP,
  getTimeSelectOptions
};
